import * as bi from 'react-bootstrap-icons';
import { Flex } from 'components';
import { PointCard } from 'shared/components';
import './style.scss';
import { IPointListPoint } from 'shared/types';

interface IProps {
  points: IPointListPoint[];
}

function PointList(props: IProps) {
  const elements: React.ReactNode[] = [];

  for (let i = 0; i < props.points.length; i++) {
    const prop = props.points[i];
    elements.push(
      <PointCard
        key={i}
        {...prop}
      />
    );

    if (i < props.points.length - 1) {
      elements.push(
        <div
          className='intercity-arrow-cntr-C7qBk'
          key={`${i}_arrow`}
        >
          <bi.ArrowDown />
        </div>
      );
    }
  }

  return <Flex direction='column'>{elements}</Flex>;
}

export default PointList;
